import { render, staticRenderFns } from "./ProductInfos.vue?vue&type=template&id=5452eac6&"
import script from "./ProductInfos.vue?vue&type=script&lang=js&"
export * from "./ProductInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports